import {
  createBlankOfficeInUserStorage,
  type CreatedBlankOfficeFile
} from '../fileBrowser/createBlankOfficeInUserStorage';
import { readDefaultContentFolderPath } from '../fileBrowser/defaultContentFolderPrefs';
import type { MountSummary } from '../fileBrowser/fileBrowserApi';
import type { NewOfficeFileKind } from '../fileBrowser/fileBrowserNewFile';
import { isUserStorageMount } from '../storageFileAudit/formatters';

/**
 * Creates a blank Office file somewhere the user can write: their default content folder
 * in My Storage when the site provisions it, otherwise the root of a ReadWrite mount.
 */
export async function createBlankOfficeOnWritableMount(
  kind: NewOfficeFileKind,
  writableMounts: readonly MountSummary[]
): Promise<CreatedBlankOfficeFile> {
  const userStorage = writableMounts.find((mount) => isUserStorageMount(mount.id));
  const target = userStorage ?? writableMounts[0];
  if (!target) {
    throw new Error('You do not have write access to any storage location.');
  }
  return createBlankOfficeInUserStorage(
    kind,
    target.id,
    userStorage ? readDefaultContentFolderPath() : ''
  );
}
